import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import authReducer from '../app/authentication/authSlice';
import reportingThresholdsApi from './apis/reportingThresholdsApi';
import historicalDataApi from './apis/historicalDataApi';
import teamApi from './apis/teamApi';
import roleApi from './apis/roleApi';
import tenantsApi from './apis/tenantsApi';
import blenderApi from './apis/blenderApi';
import manageAgentApi from './apis/manageAgentApi';
import agentApi from './apis/agentApi';
import userApi from './apis/userApi';

export const store = configureStore({
    reducer: {
        //reducers\slices go here
        authState: authReducer,
        [reportingThresholdsApi.reducerPath]: reportingThresholdsApi.reducer,
        [historicalDataApi.reducerPath]: historicalDataApi.reducer,
        [teamApi.reducerPath]: teamApi.reducer,
        [roleApi.reducerPath]: roleApi.reducer,
        [tenantsApi.reducerPath]: tenantsApi.reducer,
        [blenderApi.reducerPath]: blenderApi.reducer,
        [manageAgentApi.reducerPath]: manageAgentApi.reducer,
        [agentApi.reducerPath]: agentApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            reportingThresholdsApi.middleware,
            historicalDataApi.middleware,
            teamApi.middleware,
            roleApi.middleware,
            tenantsApi.middleware,
            blenderApi.middleware,
            manageAgentApi.middleware,
            agentApi.middleware,
            userApi.middleware,
        ),
});

export type OperationType =
    | keyof typeof reportingThresholdsApi.endpoints
    | keyof typeof historicalDataApi.endpoints
    | keyof typeof teamApi.endpoints
    | keyof typeof roleApi.endpoints
    | keyof typeof tenantsApi.endpoints
    | keyof typeof blenderApi.endpoints
    | keyof typeof manageAgentApi.endpoints
    | keyof typeof agentApi.endpoints
    | keyof typeof userApi.endpoints

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;